export default "__VITE_ASSET__e8bb12c5__"